var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "panel-control flex-column flex-fill",
          class: [_vm.isRecordMode ? "d-none" : "d-flex"],
        },
        [
          _c(
            "div",
            {
              staticClass: "panel-control-content d-flex flex-column flex-fill",
            },
            [
              _c("div", { staticClass: "row mb-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "btn-toolbar w-100 justify-content-center",
                      attrs: { role: "toolbar", "aria-label": "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn-group btn-block",
                          attrs: { role: "group", "aria-label": "Actions" },
                        },
                        _vm._l(_vm.activeActions, function (action, key) {
                          return _c(
                            "button",
                            {
                              key: key,
                              staticClass: "btn btn-main min-w-auto mx-0",
                              class: {
                                "d-flex align-items-center justify-content-center":
                                  !!action.image,
                              },
                              attrs: {
                                title: action.title,
                                type: "button",
                                "data-toggle": "tooltip-city",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.applyAction(key, $event)
                                },
                              },
                            },
                            [
                              action.icon
                                ? [_c("i", { class: action.icon })]
                                : action.image
                                ? [
                                    _c("img", {
                                      staticClass: "btn-image",
                                      attrs: { src: action.image },
                                    }),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row flex-fill" }, [
                _c("div", { staticClass: "col" }, [
                  _vm.hasRecords
                    ? _c("div", { staticClass: "annotations-grid" }, [
                        _c(
                          "div",
                          { staticClass: "record-grid container-fluid" },
                          [
                            _c(
                              "div",
                              { staticClass: "row" },
                              _vm._l(_vm.recordList, function (item, idx) {
                                return _c("record-grid-item", {
                                  key: `record-${idx}`,
                                  attrs: {
                                    moduleCode: _vm.moduleCode,
                                    record: item,
                                    map: _vm.map,
                                    zoomToCollection: _vm.zoomToCollection,
                                    showHideCollection: _vm.showHideCollection,
                                  },
                                  on: {
                                    geometryHighlight: _vm.onGeometryHighlight,
                                    changeRecord: _vm.onChangeRecord,
                                    zoomToRecord: _vm.onZoomToRecord,
                                    selectedRecord: _vm.onSelectedRecord,
                                  },
                                })
                              }),
                              1
                            ),
                          ]
                        ),
                      ])
                    : _c("div", [
                        _c("span", { staticClass: "d-block text-center" }, [
                          _vm._v(_vm._s(_vm.txtNoAnnotations)),
                        ]),
                      ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.isRecordMode
        ? _c(
            "div",
            { staticClass: "panel-control d-flex flex-column flex-fill" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "panel-control-content d-flex flex-column flex-fill",
                },
                [
                  _c("record-item", {
                    ref: "RecordItem",
                    attrs: {
                      record: _vm.selectedRecord,
                      moduleCode: _vm.moduleCode,
                      reset: _vm.reset,
                      map: _vm.map,
                      readonlyFormItem: _vm.readonlyFormItem,
                      txtConfirmLeaveSession: _vm.txtConfirmLeaveSession,
                    },
                    on: {
                      geometryHighlight: _vm.onGeometryHighlight,
                      update: _vm.onChangeRecord,
                      delete: _vm.onDeleteRecord,
                      download: _vm.onExportRecord,
                      save: _vm.onSaveRecord,
                      back: _vm.onBackRecord,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.actions.import.active
        ? _c(
            "import-file",
            {
              ref: "ModalImport",
              attrs: {
                title: _vm.actions.import.title,
                txtImport: _vm.importFile.message,
                allowedFileTypes: _vm.importFile.allowedFileTypes,
                fileValidation: _vm.fileValidation,
              },
              on: { imported: _vm.onImportedFile },
            },
            [
              _c("div", { staticClass: "d-flex" }, [
                _c("div", { staticClass: "m-3 flex-grow-1" }, [
                  _c("div", { staticClass: "form-check city-form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.importFile.replace,
                          expression: "importFile.replace",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "checkbox",
                        id: `cb-replace-annotations`,
                        name: `replace-annotations`,
                      },
                      domProps: {
                        checked: Array.isArray(_vm.importFile.replace)
                          ? _vm._i(_vm.importFile.replace, null) > -1
                          : _vm.importFile.replace,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.importFile.replace,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.importFile,
                                  "replace",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.importFile,
                                  "replace",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.importFile, "replace", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: `cb-replace-annotations` },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.txtReplaceAnnotations) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }